import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Box from '@mui/material/Box';
import { ImageOptimized } from '../image/ImageOptimized';
import { useTheme } from '@mui/material/styles';
import { GradientIcon } from '../gradients/GradientIcon';
import NotificationsIcon from '@mui/icons-material/Notifications';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import CelebrationIcon from '@mui/icons-material/Celebration';
import { Collection } from 'functions/src/types/firestore/Game/Collection';
import { getCollectionLink } from '../../util/collectionLinks';
import { ComingSoonTooltip } from '../coming-soon/ComingSoonTooltip';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { formatRelative } from 'src/util/Dates';
const sx = {
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'white',
  },
};

export type CollectionCardProps = Pick<
  Collection,
  'title' | 'date' | 'imgUrl'
> & {
  gameTitle: string;
};

export function CollectionCard({
  title,
  gameTitle,
  date,
  imgUrl,
  root,
}: CollectionCardProps) {
  const [dateText, setDateText] = useState<string>('Coming Soon');
  const [available, setAvailable] = useState<boolean>(false);
  const router = useRouter();

  const handleCardClick = () => {
    if (!available) {
      return;
    }
    const link = getCollectionLink(gameTitle, title);
    return router.push(link);
  };
  const handleShareClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  useEffect(() => {
    const getMintDate = (date) => {
      if (!date) {
        return `Coming Soon`;
      }
      if (date < Date.now()) {
        // TODO: useServerTime
        setAvailable(true);
        return `Available Now`;
      }
      return formatRelative(date);
    };
    setDateText(getMintDate(date));
  }, [date]);
  const theme = useTheme();
  return (
    <Card
      variant="collection"
      onClick={handleCardClick}
      sx={{
        '&:hover': {
          cursor: available ? 'pointer' : 'default',
        },
      }}
    >
      <CardContent>
        <ImageOptimized
          src={imgUrl}
          layout={'fill'}
          alt={title}
          style={{ zIndex: -1 }}
        />
        <Box sx={{ width: '100%' }}>
          <Box sx={{ ...sx.row, paddingBottom: '-4px' }}>
            <Typography variant="h6">{title}</Typography>
          </Box>
          <Box sx={sx.row}>
            <Typography variant="body1" color={theme.palette.text.secondary}>
              {gameTitle}
            </Typography>
            <Box
              sx={{ ...sx.row, '&:hover': { cursor: 'pointer' } }}
              onClick={handleShareClick}
            >
              <ComingSoonTooltip title={'Notifications'}>
                <GradientIcon
                  gradientColor="primary.horizontal"
                  sx={{ width: '24px', height: '24px' }}
                  IconComponent={NotificationsIcon}
                />
              </ComingSoonTooltip>
              <ComingSoonTooltip title={'Share functionality'}>
                <GradientIcon
                  gradientColor="primary.horizontal"
                  IconComponent={ShareOutlinedIcon}
                  sx={{ width: '24px', height: '24px' }}
                />
              </ComingSoonTooltip>
            </Box>
          </Box>
        </Box>
      </CardContent>
      <CardActions>
        {available ? (
          <Button
            variant="outlined"
            color={'secondary'}
            startIcon={<CelebrationIcon />}
            sx={{ width: '100%', height: '40px' }}
          >
            <Typography variant={'buttonLargeSecondary'}>{dateText}</Typography>
          </Button>
        ) : (
          <Button
            variant="outlined"
            color={'primary'}
            startIcon={<QueryBuilderIcon />}
            sx={{ width: '100%', height: '40px' }}
          >
            <Typography variant={'buttonLarge'}>{dateText}</Typography>
          </Button>
        )}
      </CardActions>
    </Card>
  );
}
